import { ReactNode } from "react";
import { styled, Typography, TypographyProps } from "@mui/material";

interface TextProps extends TypographyProps {
  text: string | ReactNode;
}

const TextStyles = styled(Typography)(({ theme }) => ({
  color: theme.palette.app.secondaryFont,
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "22px",
  whiteSpace: "pre-line",
}));

const Text = ({ text, ...props }: TextProps) => {
  return <TextStyles {...props}>{text}</TextStyles>;
};

export default Text;
